import React, { useRef } from 'react';
import JoditEditor from 'jodit-react';

const RichText = ({ content, setContent }) => {
  const editor = useRef(null);

  const config = {
    readonly: false,
    defaultActionOnPasteFromWord: 'insert_clear_html',
    askBeforePasteFromWord: false
  };

  return (
    <div>
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        onBlur={newContent => setContent(newContent)}
        onChange={newContent => {}}
      />
    </div>
  );
};

export default RichText;
